import React, { useContext, useEffect, useRef, useState } from "react";
import {
    deleteChat,
    listMessageSuport,
    listUserMessageSuport,
    markChatAsResolved,
    sendMessageSupport,
} from "../../api/context/support";
import moment from "moment/moment";
import { RiCustomerService2Line, RiMore2Fill } from "react-icons/ri";
import { FiArrowLeft, FiCheckCircle, FiImage, FiMessageCircle, FiPaperclip, FiRefreshCw, FiSearch, FiSend, FiTrash2 } from "react-icons/fi";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { SelectionContext } from "../../Context/Store";

 
 const useOutsideClick = (ref, callback) => {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    callback();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, callback]);
    };

const AVATAR_PALETTE = [
    { bg: '#ef4444', fg: '#fff' }, // A · red
    { bg: '#f97316', fg: '#fff' }, // B · orange
    { bg: '#f59e0b', fg: '#fff' }, // C · amber
    { bg: '#eab308', fg: '#fff' }, // D · yellow
    { bg: '#84cc16', fg: '#fff' }, // E · lime
    { bg: '#22c55e', fg: '#fff' }, // F · green
    { bg: '#10b981', fg: '#fff' }, // G · emerald
    { bg: '#14b8a6', fg: '#fff' }, // H · teal
    { bg: '#06b6d4', fg: '#fff' }, // I · cyan
    { bg: '#0ea5e9', fg: '#fff' }, // J · sky
    { bg: '#3b82f6', fg: '#fff' }, // K · blue
    { bg: '#6366f1', fg: '#fff' }, // L · indigo
    { bg: '#8b5cf6', fg: '#fff' }, // M · violet
    { bg: '#a855f7', fg: '#fff' }, // N · purple
    { bg: '#d946ef', fg: '#fff' }, // O · fuchsia
    { bg: '#ec4899', fg: '#fff' }, // P · pink
    { bg: '#f43f5e', fg: '#fff' }, // Q · rose
    { bg: '#dc2626', fg: '#fff' }, // R · deep red
    { bg: '#ea580c', fg: '#fff' }, // S · deep orange
    { bg: '#d97706', fg: '#fff' }, // T · deep amber
    { bg: '#65a30d', fg: '#fff' }, // U · deep lime
    { bg: '#16a34a', fg: '#fff' }, // V · deep green
    { bg: '#0d9488', fg: '#fff' }, // W · deep teal
    { bg: '#0891b2', fg: '#fff' }, // X · deep cyan
    { bg: '#2563eb', fg: '#fff' }, // Y · deep blue
    { bg: '#7c3aed', fg: '#fff' }, // Z · deep violet
];

const getAvatarStyle = (name) => {
    const letter = (name || 'U').charAt(0).toUpperCase();
    const code = letter.charCodeAt(0);
    const index = code >= 65 && code <= 90 ? code - 65 : 20;
    const { bg, fg } = AVATAR_PALETTE[index];
    return { background: bg, color: fg };
};

const formatDateSeparator = (date) => {
    const m = moment(date);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');
    const weekAgo = moment().subtract(6, 'days').startOf('day');
    if (m.isSame(today, 'day')) return 'TODAY';
    if (m.isSame(yesterday, 'day')) return 'YESTERDAY';
    if (m.isAfter(weekAgo)) return m.format('dddd').toUpperCase();
    return m.format('DD MMMM YYYY').toUpperCase();
};

const ChatSupport = () => {

 
    const location = useLocation();
    const { chatId } = location.state || {};

    const [showOptionsMenu, setShowOptionsMenu] = useState(false);
    const optionsMenuRef = useRef(null);
    const fileInputRef = useRef(null);
    const messagesEndRef = useRef(null);

    const { messages, setMessages, messageUpdate, setMessageUpdate } =
        useContext(SelectionContext);

    const [users, setUsers] = useState([]);
    const [selectedChatRoom, setSelectedChatRoom] = useState(null);
    const [newMessage, setNewMessage] = useState("");
    const [attachment, setAttachment] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreMessages, setHasMoreMessages] = useState(true);
    const [userSearch, setUserSearch] = useState("");
    const [refreshing, setRefreshing] = useState(false);

    // Fetch the user list and messages for the selected user
    useEffect(() => {
        fetchUserList();
    }, []);

    const handleRefresh = () => {
        if (refreshing) return;
        setRefreshing(true);
        fetchUserList(() => {
            if (selectedChatRoom) {
                fetchMessages(selectedChatRoom, true);
            }
            setRefreshing(false);
            toast.success("Refreshed");
        });
    };


    const fetchUserList = (onDone) => {
        listUserMessageSuport()((response) => {
            if (response?.status) {
                setUsers(response?.data?.data);
                // If chatId is provided, find and select the corresponding chat room
                if (chatId) {
                    const chatRoom = response?.data?.data.find(
                        (room) => room.chatRoomId === chatId
                    );
                    if (chatRoom) {
                        setSelectedChatRoom(chatRoom);
                        fetchMessages(chatRoom, true);
                    }
                }
            } else {
                setUsers([]);
            }
            if (typeof onDone === "function") onDone();
        });
    };

          // Add this to close the menu when clicking outside
    useOutsideClick(optionsMenuRef, () => {
        setShowOptionsMenu(false);
    });

    const fetchMessages = (chatRoom, reset = false) => {
        if (!chatRoom) return;

        setLoading(true);
        if (reset) {
            setPage(1);
            setMessages([]);
        }

        listMessageSuport({ chatRoomId: chatRoom?.chatRoomId, page })((response) => {
            if (response?.data?.status) {
                const newMessages = response?.data?.data;
                setMessages((prevMessages) =>
                    reset ? newMessages : [...newMessages, ...prevMessages]
                );
                scrollToBottom(newMessages);
                setHasMore(newMessages.length > 0);
            } else {
                setMessages([]);
                setHasMore(false);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        if (messageUpdate) {
            if (selectedChatRoom) {
                fetchMessages(selectedChatRoom, true);
            }
            setMessageUpdate(false);
        }
    }, [messageUpdate]);

    const scrollToBottom = (newMessages) => {
        const firstMessageId = newMessages?.[0]?.id;
        if (firstMessageId) {
            setTimeout(() => {
                const element = document.getElementById(firstMessageId);
                if (element) {
                    element.scrollIntoView();
                }
            }, 500);
        }
    };

    const handleMarkAsResolved = () => {
        if (!selectedChatRoom) return;

        setShowOptionsMenu(false);
        markChatAsResolved({ chatRoomId: selectedChatRoom.chatRoomId })((response) => {
            if (response.data?.status) {
                toast.success("Chat marked as resolved successfully");
                // Update the chat room status in the users list
                setUsers(prevUsers =>
                    prevUsers.map(room =>
                        room.chatRoomId === selectedChatRoom.chatRoomId
                            ? { ...room, isResolved: true }
                            : room
                    )
                );
                // Update the selected chat room status
                setSelectedChatRoom(prev => ({ ...prev, isResolved: true }));
            } else {
                toast.error(response.data?.error || "Failed to mark chat as resolved");
            }
        });
    };

    const handleDeleteChat = () => {
        if (!selectedChatRoom) return;

        setShowOptionsMenu(false);
        deleteChat({ chatRoomId: selectedChatRoom.chatRoomId })((response) => {
            if (response.data?.status) {
                toast.success("Chat deleted successfully");
                // Remove the chat room from the list
                setUsers(prevUsers =>
                    prevUsers.filter(room => room.chatRoomId !== selectedChatRoom.chatRoomId)
                );
                // Clear the current chat
                setSelectedChatRoom(null);
                setMessages([]);
            } else {
                toast.error(response.data?.error || "Failed to delete chat");
            }
        });
    };

    const handleImageChange = (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
        const validImageTypes = ["image/jpeg", "image/png", "image/gif"];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit.");
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg, png, and gif files are allowed.");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setAttachment(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const sendMessage = () => {
        if (!selectedChatRoom) return;
        if (!newMessage.trim() && !attachment) return;

        const payload = {
            chatRoomId: selectedChatRoom.chatRoomId,
            message: newMessage,
            image: attachment,
            senderType: "admin",
        };

        sendMessageSupport(payload)((response) => {
            if (response?.status) {
                setMessages((prevMessages) => [
                    {
                        id: response?.data?.id,
                        chatRoomId: selectedChatRoom.chatRoomId,
                        message: payload.message,
                        image: payload.image,
                        senderType: "admin",
                        createdAt: new Date().toISOString(),
                    },
                    ...prevMessages,
                ]);
                scrollToBottomSend();
                setNewMessage("");
                setAttachment(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            } else {
                toast.error("Failed to send message");
            }
        });
    };

    const handleUserClick = (chatRoom) => {
        setSelectedChatRoom(chatRoom);
        setMessages([]);
        setPage(1);
        setCurrentPage(1);
        setHasMoreMessages(true);
        setIsLoadingMore(false);
        fetchMessages(chatRoom, true);
    };

    const handleScroll = () => {
        const container = document.querySelector(".chat-messages");

        if (
            container?.scrollTop === 0 &&
            hasMoreMessages &&
            !isLoadingMore &&
            selectedChatRoom
        ) {
            setIsLoadingMore(true);
            const nextPage = currentPage + 1;

            listMessageSuport({
                chatRoomId: selectedChatRoom.chatRoomId,
                page: nextPage,
            })((response) => {
                if (response?.data?.status && response?.data?.data?.length > 0) {
                    let currentScrollId = null;
                    setMessages((prev) => {
                        const newMessages = [...prev, ...response.data.data];
                        currentScrollId = prev[prev.length - 1];
                        return newMessages;
                    });
                    scrollToBottomMessage(currentScrollId);
                    setCurrentPage(nextPage);
                    setHasMoreMessages(response.data.data.length > 0);
                } else {
                    setHasMoreMessages(false);
                }
                setIsLoadingMore(false);
            });
        }
    };

   

    const scrollToBottomMessage = (newMessages) => {
        const lastMessageId = newMessages?.id;
        if (lastMessageId) {
            const element = document.getElementById(lastMessageId);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView();
                }, 500);
            }
        }
    };

    const scrollToBottomSend = () => {
        const scrollableDiv = document.querySelector(".chat-messages");
        if (scrollableDiv) {
            scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
        }
    };

    useEffect(() => {
        if (messages.length > 0) {
            scrollToBottomSend();
        }
    }, [messages]);

    const filteredUsers = users.filter((chatRoom) => {
        const searchValue = userSearch.trim().toLowerCase();
        if (!searchValue) return true;
        return `${chatRoom?.user?.firstName || ""} ${chatRoom?.user?.mobile || ""}`
            .toLowerCase()
            .includes(searchValue);
    });

    return (
        <div className={`chat-support-page${selectedChatRoom ? ' has-selected' : ''}`}>
            <div className="page-header-sticky chat-support-header-bar">
                <div className="chat-support-title-block">
                    <h3>Chat Support</h3>
                    <p>Reply to customer conversations in real time.</p>
                </div>
                <button
                    type="button"
                    className={`chat-refresh-btn${refreshing ? ' is-spinning' : ''}`}
                    onClick={handleRefresh}
                    disabled={refreshing}
                    aria-label="Refresh"
                    title="Refresh"
                >
                    <FiRefreshCw />
                    <span className="chat-refresh-label">Refresh</span>
                </button>
            </div>
            <div className="chat-container">
                {/* User List */}
                <div className="user-list">
                    <label className="chat-search">
                        <FiSearch />
                        <input value={userSearch} onChange={(e) => setUserSearch(e.target.value)} placeholder="Search by name or number" />
                    </label>
                    <div className="user-list-items">
                    {filteredUsers?.map((chatRoom) => (
                        <div
                            key={chatRoom.chatRoomId}
                            className={`user-item ${selectedChatRoom?.chatRoomId === chatRoom.chatRoomId
                                ? "selected"
                                : ""
                                }`}
                            onClick={() => handleUserClick(chatRoom)}
                        >
                            <div className="user-avatar" style={getAvatarStyle(chatRoom?.user?.firstName)}>{(chatRoom?.user?.firstName || "U").charAt(0).toUpperCase()}</div>
                            <div className="user-item-content">
                                <span className="user-item-name">{chatRoom.user.firstName || 'user'}</span>
                                <span className="user-item-meta">{chatRoom.user.mobile || ""}</span>
                            </div>
                        </div>
                    ))}
                    {!filteredUsers.length && <div className="chat-list-empty">No conversations found</div>}
                    </div>
                </div>

                {/* Chat Area */}
                <div className="chat-area">
                    {selectedChatRoom ? (
                        <>
                            <div className="support-chat-header">
                                <div className="support-chat-header-content">
                                    <button
                                        type="button"
                                        className="chat-back-btn"
                                        onClick={() => setSelectedChatRoom(null)}
                                        aria-label="Back to conversations"
                                        title="Back"
                                    >
                                        <FiArrowLeft />
                                    </button>
                                    <div className="user-name-with-status">
                                        <div className="active-user-avatar" style={getAvatarStyle(selectedChatRoom.user.firstName)}>{(selectedChatRoom.user.firstName || "U").charAt(0).toUpperCase()}</div>
                                        <div>
                                        <span className="user-name">{selectedChatRoom.user.firstName || 'user'}</span>
                                        <span className="user-mobile">{selectedChatRoom.user.mobile || ''}</span>
                                        </div>
                                        {selectedChatRoom.isResolved && <span className="resolved-badge"><FiCheckCircle /> Resolved</span>}

                                    </div>
                                    <div className="support-chat-options" ref={optionsMenuRef}>
                                        <RiMore2Fill
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowOptionsMenu(!showOptionsMenu);
                                            }}
                                            className="support-chat-options-icon"
                                            title="Conversation options"
                                        />
                                        {showOptionsMenu && (
                                            <div className="support-chat-options-dropdown">
                                                {!selectedChatRoom.isResolved && (
                                                    <button
                                                        type="button"
                                                        className="support-chat-options-item"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleMarkAsResolved();
                                                        }}
                                                        >
                                                            <FiCheckCircle /> Mark as resolved
                                                        </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="support-chat-options-item"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteChat();
                                                    }}
                                                ><FiTrash2 /> Delete chat</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div
                                className="chat-messages"
                                onScroll={handleScroll}
                                style={{ overflowY: "auto" }}
                            >
                                {(() => {
                                    const ordered = [...messages].reverse();
                                    let prevDateKey = null;
                                    return ordered.map((msg) => {
                                        const isSent = msg.senderType === "admin" || msg.senderType === "customerSupport";
                                        const dateKey = moment(msg?.createdAt).format("YYYY-MM-DD");
                                        const showDateSeparator = dateKey !== prevDateKey;
                                        prevDateKey = dateKey;
                                        return (
                                            <React.Fragment key={msg.id}>
                                                {showDateSeparator && (
                                                    <div
                                                        style={{
                                                            alignSelf: "center",
                                                            margin: "10px 0 6px",
                                                            padding: "5px 12px",
                                                            background: "rgba(225, 245, 254, .92)",
                                                            color: "#54656f",
                                                            fontSize: "11px",
                                                            fontWeight: 500,
                                                            letterSpacing: ".02em",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 1px 0.5px rgba(11, 20, 26, .13)",
                                                        }}
                                                    >
                                                        {formatDateSeparator(msg?.createdAt)}
                                                    </div>
                                                )}
                                        <div
                                            id={msg?.id}
                                            style={{
                                                position: "relative",
                                                alignSelf: isSent ? "flex-end" : "flex-start",
                                                maxWidth: "min(72%, 480px)",
                                                padding: "6px 10px 20px",
                                                borderRadius: isSent ? "8px 2px 8px 8px" : "2px 8px 8px 8px",
                                                background: isSent ? "#d9fdd3" : "#ffffff",
                                                color: "#111b21",
                                                fontSize: "12px",
                                                lineHeight: 1.45,
                                                wordWrap: "break-word",
                                                whiteSpace: "pre-wrap",
                                                boxShadow: "0 1px 0.5px rgba(11, 20, 26, .13)",
                                            }}
                                        >
                                            {msg.image && (
                                                <img
                                                    src={msg.image}
                                                    alt="Attachment"
                                                    style={{
                                                        display: "block",
                                                        maxWidth: "min(100%, 320px)",
                                                        maxHeight: "300px",
                                                        marginBottom: "4px",
                                                        borderRadius: "6px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            )}
                                            <span style={{ display: "block", paddingRight: "48px" }}>{msg?.message}</span>
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    bottom: "4px",
                                                    fontSize: "10px",
                                                    fontWeight: 400,
                                                    color: "#667781",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                {moment(msg?.createdAt).format("hh:mm A")}
                                            </span>
                                        </div>
                                            </React.Fragment>
                                        );
                                    });
                                })()}
                            </div>

                            {selectedChatRoom.isResolved ? (
                                <div className="resolved-chat-notice">
                                    This chat has been resolved
                                </div>
                            ) : (
                                <div className="chat-input-area">
                                    <textarea
                                        value={newMessage}
                                        onChange={(e) => setNewMessage(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && !e.shiftKey) {
                                                e.preventDefault();
                                                sendMessage();
                                            }
                                        }}
                                        placeholder="Write a reply..."
                                        rows={1}
                                        className="message-textarea"
                                    />
                                    <input type="file" accept="image/*" ref={fileInputRef} onChange={handleImageChange} id="chat-attachment" hidden />
                                    <label htmlFor="chat-attachment" className="chat-attachment-button" title="Attach an image"><FiPaperclip /></label>
                                    {attachment && <span className="attachment-ready"><FiImage /> Image ready</span>}
                                    <button onClick={sendMessage} disabled={!newMessage.trim() && !attachment}><FiSend /> <span>Send</span></button>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="chat-placeholder">
                            <div className="chat-placeholder-icon"><RiCustomerService2Line /></div>
                            <strong>Chat Support Console</strong>
                            <span className="chat-placeholder-sub">Pick a customer from the left to view their conversation and reply in real time.</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChatSupport;